<template>
  <ul class="footer-socials">
    <li>
      <a href="https://twitter.com/asoundeffect" class="footer-socials__link" target="_blank">
        <icon-twitter />
      </a>
    </li>
    <li>
      <a href="https://www.facebook.com/asoundeffects" class="footer-socials__link" target="_blank">
        <icon-facebook />
      </a>
    </li>
    <li>
      <a href="https://www.linkedin.com/company/asoundeffect/" class="footer-socials__link" target="_blank">
        <icon-linkedin />
      </a>
    </li>
    <li>
      <a href="https://www.instagram.com/asoundeffect_/" class="footer-socials__link" target="_blank">
        <icon-instagram />
      </a>
    </li>
    <li>
      <a href="https://www.youtube.com/c/asoundeffect" class="footer-socials__link" target="_blank">
        <icon-youtube />
      </a>
    </li>
    <li>
      <a href="https://soundcloud.com/a-sound-effect" class="footer-socials__link" target="_blank">
        <icon-soundcloud />
      </a>
    </li>
  </ul>
</template>

<script setup lang="ts">
import IconTwitter from '~/assets/icons/IconSocialXTwitter.svg';
import IconFacebook from '~/assets/icons/IconSocialFacebook.svg';
import IconLinkedin from '~/assets/icons/IconShareLinkedin.svg';
import IconInstagram from '~/assets/icons/IconSocialInstagram.svg';
import IconYoutube from '~/assets/icons/IconSocialYoutube.svg';
import IconSoundcloud from '~/assets/icons/IconSocialSoundcloud.svg';

</script>

<style lang="scss">
@use "~/common/scss/helpers";

.footer-socials {
  align-items: center;
  display: flex;
  gap: helpers.px-to-rem(12);
  list-style: none;
  padding: 0 0;

  &__link {
    display: block;
    height: helpers.px-to-rem(20);
    transition: color .25s;
    width: helpers.px-to-rem(20);

    &:hover {
      color: var(--color-orange);
    }

    svg {
      height: 100%;
      width: 100%;
    }
  }
}
</style>
